require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-region-america-latina-y-el-caribe.json") })
        }
      }, "path---es-mx-region-america-latina-y-el-caribe");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-region-america-latina-y-el-caribe!./.cache/json/es-mx-region-america-latina-y-el-caribe.json
// module id = 903
// module chunks = 231608221292675